import React from "react"
import { Link } from "react-router-dom"
import { P } from "@infotech/uikit-text"
import styles from "./styles.css"

const NotFoundPage = () => (
  <div className={styles.Container}>
    <div>
      <P className={styles.NotFoundCaption}>404</P>
    </div>
    <div>
      <P className={styles.InfoBold}>
        Страница, на которую вы перешли, не существует.
      </P>
    </div>
    <div>
      <P className={styles.Info}>В адресе есть ошибка, или страница удалена.</P>
    </div>
    <div>
      <Link to="/calendar" className={styles.Link}>
        Перейти на главную страницу
      </Link>
    </div>
  </div>
)

export default NotFoundPage
